import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import { useTranslation } from "react-i18next";

const SpecialOffers = ({ offer_list }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full pb-20">
      <Heading heading={t("home.Special_Offers")} />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">

        {offer_list.map((item, index) => (

          <Product
            key={index}
            index={index}
            _id={item.id}
            img={`https://back.kayanmarketeg.com/img/${item.image}`}
            productName={item.name}
            price={item.price}
            badge={true}
            des={item.detail}
            catName={item.category.catName}
            catId={item.category.id}
            displayPrice={item.displayPrice}
            recipe={item.recipe}
            unitName={item.unitName}
            unitValue={item.unitValue}
          />
        ))}


      </div>
    </div>
  );
};

export default SpecialOffers;
